<template>
<div class="chapter">
<div class="inner_page">
<div class="section" id="section005">
<div class="pseudo_margin_2"></div>
<div class="pseudo_margin_2"></div>
<p class="poem_title1"><span class="right_1" epub:type="pagebreak" id="page_vi" title="vi"><span class="right_1" epub:type="pagebreak" id="page_vii" title="vii">CONTENTS</span></span></p>
<div class="pseudo_margin_2"></div>
<ul>
<li><span href="#/text/title_page" title="Link target outside of Sample">Title Page</span></li>
<li><span href="#/text/Copyright" title="Link target outside of Sample">Copyright</span></li>
<li><span href="#/text/Dedication" title="Link target outside of Sample">Dedication</span></li>
</ul>
<div class="pseudo_margin_1"></div>
<ol>
<li><a href="#/text/Chapter01#ch1">The Debt</a></li>
<li><span href="#/text/Chapter02#ch2" title="Link target outside of Sample">Post-Elegy</span></li>
<li><span href="#/text/Chapter03#ch3" title="Link target outside of Sample">Swallows</span></li>
<li><span href="#/text/Chapter04#ch4" title="Link target outside of Sample">The First Year</span></li>
<li><span href="#/text/Chapter05#ch5" title="Link target outside of Sample">Inside the Book</span></li>
<li><span href="#/text/Chapter06#ch6" title="Link target outside of Sample">The People’s History</span></li>
<li><span href="#/text/Chapter07#ch7" title="Link target outside of Sample">House Near the Airport</span></li>
<li><span href="#/text/Chapter08#ch8" title="Link target outside of Sample">Consumers in Rowboat</span></li>
<li><span href="#/text/Chapter09#ch9" title="Link target outside of Sample">Post-Elegy</span>
<div class="pseudo_margin_1"></div></li>
<li><span href="#/text/Chapter10#ch10" title="Link target outside of Sample">Marriage</span></li>
<li><span href="#/text/Chapter11#ch11" title="Link target outside of Sample">The Next Generation</span></li>
<li><span href="#/text/Chapter12#ch12" title="Link target outside of Sample">The Mind Sliding</span></li>
<li><span href="#/text/Chapter13#ch13" title="Link target outside of Sample">Leaving the Hospital</span></li>
<li><span href="#/text/Chapter14#ch14" title="Link target outside of Sample">A Bit about the Soul</span></li>
<li><span href="#/text/Chapter15#ch15" title="Link target outside of Sample">The Affair</span></li>
<li><span href="#/text/Chapter16#ch16" title="Link target outside of Sample">Prayers (w/Answers)</span></li>
<li><span href="#/text/Chapter17#ch17" title="Link target outside of Sample">Report from the Provinces</span></li>
<li><span href="#/text/Chapter18#ch18" title="Link target outside of Sample">Image: Postmodernity</span></li>
<li><span href="#/text/Chapter19#ch19" title="Link target outside of Sample">Post-Elegy</span></li>
<li><span href="#/text/Chapter20#ch20" title="Link target outside of Sample">On Language</span>
<div class="pseudo_margin_1"></div></li>
<li><span href="#/text/Chapter21#ch21" title="Link target outside of Sample">A Breath in the Record</span></li>
<li><span href="#/text/Chapter22#ch22" title="Link target outside of Sample">Allegory of the House</span></li>
<li><span class="right_1" epub:type="pagebreak" id="page_viii" title="viii"><span href="#/text/Chapter23#ch23" title="Link target outside of Sample">Post-Elegy</span></span></li>
<li><span href="#/text/Chapter24#ch24" title="Link target outside of Sample">Landings</span>
<div class="pseudo_margin_1"></div></li>
<li><span href="#/text/Chapter25#ch25" title="Link target outside of Sample">Ballad (American, 21st Century)</span></li>
<li><span href="#/text/Chapter26#ch26" title="Link target outside of Sample">Hoax Bomb</span></li>
<li><span href="#/text/Chapter27#ch27" title="Link target outside of Sample">Some Notes on Human Relations</span></li>
<li><span href="#/text/Chapter28#ch28" title="Link target outside of Sample">Image: Psychotherapy</span></li>
<li><span href="#/text/Chapter29#ch29" title="Link target outside of Sample">21st Century Museum</span></li>
<li><span href="#/text/Chapter30#ch30" title="Link target outside of Sample">For Harper, 20 Months Old</span></li>
<li><span href="#/text/Chapter31#ch31" title="Link target outside of Sample">Allegory of the Boat</span></li>
<li><span href="#/text/Chapter32#ch32" title="Link target outside of Sample">Post-Elegy</span></li>
<li><span href="#/text/Chapter33#ch33" title="Link target outside of Sample">On Breathing</span></li>
<li><span href="#/text/Chapter34#ch34" title="Link target outside of Sample">Envoi</span></li>
</ol>
<div class="pseudo_margin_1"></div>
<ul>
<li><span href="#/text/Notes#bm1" title="Link target outside of Sample"><em>Notes</em></span></li>
<li><span href="#/text/Acknowledgments#bm2" title="Link target outside of Sample"><em>Acknowledgments</em></span></li>
<li><span href="#/text/Author" title="Link target outside of Sample"><em>About the Author</em></span></li>
</ul>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Toc.vue?44a4dfd5